import React from "react";
import { Link } from "react-router-dom";
import {
    Button,
    Tooltip,
    Position,
    Icon,
    IconSize,
} from "@blueprintjs/core";

import { useRecoilState } from 'recoil';
import { siteModeAtom } from "../../atoms";
import FileUploadButton from "../../pages/Collection/PredictionsUpload/PredictionsUploadButton";

import "./Navbar.scss"

// const DEFAULT_LOGO_URL = "/static/ego4d-logo-purple.png"

function Navbar({ locallyFilteredData, prevPage, logoUrl, children }) {
    const [siteMode, setSiteMode] = useRecoilState(siteModeAtom)

    // const total_duration_seconds = locallyFilteredData?.map((v) => (v['duration'] || 0)).reduce((s, a) => s + a, 0);
    const download_video_uids = (locallyFilteredData) => {
        let video_uids = !!locallyFilteredData ? locallyFilteredData.map(o => o['video_uid']) : []
        const element = document.createElement("a");
        const file = new Blob([video_uids.join("\n")], {
            type: "text/plain"
        });
        element.href = URL.createObjectURL(file);
        element.download = "ego4d_subset_ids.txt";
        document.body.appendChild(element);
        element.click();
    }

    const LogoComponent = !!prevPage ? <Link to={prevPage} className='navbar-prevpage-container'>
        <Icon icon="caret-left" className="navbar-prevpage-caret" size={IconSize.LARGE} />
        {logoUrl && <img className='header-logo' src={logoUrl} alt="logo" />}
    </Link>
        : <Link to={'/login'} className='navbar-prevpage-container'>
            {logoUrl && <img className='header-logo' src={logoUrl} alt="logo" />}
        </Link>;

    const edit_icon = <Tooltip content="Edit Annotations" position={Position.BOTTOM} openOnTargetFocus={false}>
        <Button icon='edit' className={"navbar-icon" + (siteMode == 'edit' ? ' active' : '')}
            onClick={() => setSiteMode(siteMode == 'edit' ? 'view' : 'edit')} />
    </Tooltip>;

    const help_icon = <Tooltip content="Viz Docs" position={Position.BOTTOM} openOnTargetFocus={false}>
        <a href="https://ego4d-data.org/docs/viz/" target="_blank" rel="noreferrer">
            <Button icon='help' className="navbar-icon" />
        </a>
    </Tooltip>;

    const download_icon = <Tooltip content="Download UIDs from Search / Filter" position={Position.BOTTOM} openOnTargetFocus={false}>
        <Button icon='download' onClick={() => download_video_uids(locallyFilteredData)} className="navbar-icon" />
    </Tooltip>;

    return <div className='navbar'>
        <div className="navbar-row-search">
            {LogoComponent}
            {children}
            <div style={{ display: 'flex', justifyContent: 'end' }}>
                {/* {edit_icon} */}
                <FileUploadButton />
                {help_icon}
                {!!locallyFilteredData && download_icon}
            </div>
        </div>
    </div>
}

export { Navbar };